import TrainingPlansDrawerEntries from "@Components/training-plans/training-plans-drawer/training-plans-drawer-entries";
import TrainingPlansDrawerHeader from "@Components/training-plans/training-plans-drawer/training-plans-drawer-header";
import TrainingPlansDrawerLoadingState from "@Components/training-plans/training-plans-drawer/training-plans-drawer-loading-state";
import TrainingPlansDrawerProgress from "@Components/training-plans/training-plans-drawer/training-plans-drawer-progress";
import { DrawerBodyStack, DrawerContentStack, DrawerRoot } from "@Components/training-plans/training-plans-drawer/training-plans-drawer.styled";
import { TrainingPlansDrawerProvider, useTrainingPlansDrawerContext } from "@Context/game/training-plans/training-plans-drawer-context";

const TrainingPlansDrawerContent = () => {
  const { closeDrawer, isBuildingPlan, isDrawerOpen, isLoading } = useTrainingPlansDrawerContext();

  return (
    <DrawerRoot anchor="right" open={isDrawerOpen} onClose={closeDrawer}>
      <DrawerContentStack spacing={3}>
        <TrainingPlansDrawerHeader />

        {isLoading ? (
          <TrainingPlansDrawerLoadingState isBuilding={isBuildingPlan} />
        ) : (
          <DrawerBodyStack spacing={3}>
            <TrainingPlansDrawerProgress />
            <TrainingPlansDrawerEntries />
          </DrawerBodyStack>
        )}
      </DrawerContentStack>
    </DrawerRoot>
  );
};

const TrainingPlansDrawer = () => {
  return (
    <TrainingPlansDrawerProvider>
      <TrainingPlansDrawerContent />
    </TrainingPlansDrawerProvider>
  );
};

export default TrainingPlansDrawer;
